import axios from "axios";
import {
    URLAPI,
    COST_CENTER_PATH,
    COST_CENTER_CREATE_PATH,
    COST_CENTER_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'

const init = {
    _get_all_cost_centers: {
        data: [],
        status: 0,
        message: {},
    },
    _create_cost_centers: {
        data: {},
        status: 0,
        message: {},
    },
    _update_cost_centers: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_COST_CENTERS_SUCCESS = "GET_ALL_COST_CENTERS_SUCCESS";
export const CREATE_COST_CENTERS_SUCCESS = "CREATE_COST_CENTERS_SUCCESS";
export const UPDATE_COST_CENTERS_SUCCESS = "UPDATE_COST_CENTERS_SUCCESS";

export const cost_center_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_COST_CENTERS_SUCCESS:
            return {
                ...state,
                _get_all_cost_centers: action.payload,
            };
        case CREATE_COST_CENTERS_SUCCESS:
            return {
                ...state,
                _create_cost_centers: action.payload,
            };
        case UPDATE_COST_CENTERS_SUCCESS:
            return {
                ...state,
                _update_cost_centers: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const get_all_cost_centers = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${COST_CENTER_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_COST_CENTERS_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_COST_CENTERS_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_COST_CENTERS_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const create_cost_centers = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(`${URLAPI}${COST_CENTER_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: CREATE_COST_CENTERS_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_COST_CENTERS_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: (error.response.data && error.response.data.mensaje) ||
                        "Ocurrió un error al crear el centro de costo",
                },
            });
        } else {
            dispatch({
                type: CREATE_COST_CENTERS_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "No se pudo conectar con el servidor. Intente nuevamente.",
                },
            });
        }
    }
}


export const update_cost_centers = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${COST_CENTER_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_COST_CENTERS_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_COST_CENTERS_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_COST_CENTERS_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}


export const clear_cost_center = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}
